import EditorialErrors from '@/components/EditorialErrors/EditorialErrors';
import { FC } from 'react';

const OptiesErrorsRoute: FC = () => {
	return (
		<main className="grid min-h-full gap-4 divide-y-2 divide-dotted overflow-y-auto bg-gray-50 p-4">
			<h1 className="font-brand text-4xl">Fouten in toegankelijkheid</h1>
			<EditorialErrors />
		</main>
	);
};

export default OptiesErrorsRoute;
